<template>
    <div class="seckillSetting">
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{ setTingObj.titleShow.title }}</span>
                <SwitchButton :value="setTingObj.titleShow"></SwitchButton>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.priceShow.title }}</span>
                <SwitchButton :value="setTingObj.priceShow"></SwitchButton>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.discountShow.title }}</span>
                <SwitchButton :value="setTingObj.discountShow"></SwitchButton>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.seckillShow.title }}</span>
                <SwitchButton :value="setTingObj.seckillShow"></SwitchButton>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.themeColor.title}}</span>
                <color :colorObj="setTingObj.themeColor"></color>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.conStyle.title}} ({{setTingObj.conStyle.list[setTingObj.conStyle.type].val}})</span>
                <radio :list="setTingObj.conStyle.list" :type="setTingObj.conStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lrConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.prConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import radio from '@/components/decoration/common/radio.vue';
import color from '@/components/decoration/common/color.vue';
import SwitchButton from '@/components/decoration/common/switchButton.vue';

export default {
    components: { SwitchButton, color, radio, sliderAndInput, tab },
    data(){
        return{
            status: 'content'
        }
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    methods:{
        getTab(e){
            this.status = e
        },
        updateBgStyle(type){
            this.setTingObj.conStyle.type = type
        },
    }
}
</script>

<style scoped lang="scss">

</style>